import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { useCallback } from "react";
import { AI_WORKSPACE_QUERY_KEYS } from "../constants";
import { AiWorkspaceService } from "../services/aiWorkspace.service";
import { IUpdateVetRequestPromptPayload } from "../types";
import { readApiError } from "./readApiError";

const QUERY_OPTIONS = {
  queryKey: [AI_WORKSPACE_QUERY_KEYS.REQUESTS],
  skipInvalidation: false,
};

export function useUpdateVetRequestPrompt(config?: {
  onSuccess?: (prompt: string) => void;
}) {
  const updateRequestPrompt = useCallback(
    (payload: IUpdateVetRequestPromptPayload) =>
      AiWorkspaceService.updateVetRequestPrompt(payload)
        .then((res) => {
          ToastService.success("Request prompt saved");
          return res;
        })
        .catch(async (err) => {
          ToastService.error(
            await readApiError(err, "Failed to save request prompt")
          );
          throw err;
        }),
    []
  );

  const { mutate: update, isLoading: isUpdating } =
    useMutation<IUpdateVetRequestPromptPayload>({
      mutationFn: updateRequestPrompt,
      options: QUERY_OPTIONS,
      onSuccess: (queryClient, _data, variables) => {
        queryClient.invalidateQueries({
          queryKey: [
            AI_WORKSPACE_QUERY_KEYS.REQUEST,
            variables.aiWorkspaceRequestId,
          ],
        });
        config?.onSuccess?.(variables.prompt);
      },
    });

  return { update, isUpdating };
}
